<div class="custom-mat-dialog-form add-project-modal">
  <div class="header-container">
    <h4>{{isEditMode ? 'Update' : 'Create new'}} Project {{isEditMode ? currentProject.id : ''}} - MgmtID: {{managementId}}</h4>
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-sm-6 form-group">
          <mat-label><span>Point of contact</span><span class="orange-asterisk"> *</span></mat-label>
          <ng-select
            [items]="incoUsers"
            bindLabel="displayName"
            bindValue="mail"
            [searchable]="true"
            [clearable]="false"
            formControlName="responsibleUser">
            <ng-template ng-label-tmp let-item="item">
              <span class="ng-value-label" [title]="item.mail">{{ item.displayName }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div class="poc-option">
                <div class="poc-name">{{ item.displayName }}</div>
                <div class="poc-upn">{{ item.mail }}</div>
              </div>
            </ng-template>
          </ng-select>
          @if (form.get('responsibleUser')?.touched && form.get('responsibleUser')?.hasError('required')) {
            <mat-error class="poc-error">Point of contact is required</mat-error>
          }
        </div>
        <div class="col-sm-6 form-group">
          <mat-label><span>Project Title</span><span class="orange-asterisk"> *</span></mat-label>
          <input class="text-input" formControlName="projectTitle" latinTextOnly>
          @if (form.get('projectTitle')?.touched && form.get('projectTitle')?.hasError('required')) {
            <mat-error class="poc-error">Project Title is required</mat-error>
          }
        </div>

      </div>
      <div class="row">
        <div class="col-sm-6 form-group">
          <mat-label> <span>Multiproject</span></mat-label>
          <ng-select
            [items]="multiprojects"
            bindLabel="name"
            bindValue="id"
            [searchable]="true"
            formControlName="multiprojectId">
          </ng-select>
        </div>
        <div class="col-sm-6 form-group">
          <mat-label> <span>Investment Type</span><span class="orange-asterisk"> *</span></mat-label>
          <ng-select  [items]="investmentTypes"
            [searchable]="true"
            [clearable]="false"
            bindLabel="investmentName"
            bindValue="id"
            formControlName="investmentTypeId">
          </ng-select>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 form-group">
          <mat-label> <span>Phase</span><span class="orange-asterisk"> *</span></mat-label>
          <ng-select  [items]="projectPhases"
            [searchable]="true"
            [clearable]="false"
            bindLabel="phaseName"
            bindValue="id"
            formControlName="phaseId">
          </ng-select>
        </div>
      </div>
      <div>
        <h5>Categories</h5>
      </div>
      <div class="row">
        <div class="col-sm-4 checkbox-group">
          <input type="checkbox" formControlName="informationTechnology"/> <span>IT</span>
        </div>
        <div class="col-sm-4 checkbox-group">
          <input type="checkbox" formControlName="manufacturing"/> <span>MFG</span>
        </div>
        <div class="col-sm-4 checkbox-group">
          <input type="checkbox" formControlName="fieldOperations"/> <span>FLD</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 checkbox-group">
          <input type="checkbox" formControlName="researchDevelopment"/> <span>R&D | local R&D</span>
        </div>
        <div class="col-sm-4 checkbox-group">
          <input type="checkbox" formControlName="bigR"/> <span>R&D | BigR</span>
        </div>
      </div>
      <div class="form-group">
        @if (form.hasError('atLeastOneBoolean')) {
          <mat-error>
            Please, select at least one category.
          </mat-error>
        }
      </div>
      <div class="row">
        <div class="col-sm-6 form-group">
          <mat-form-field appearance="outline">
            <mat-label>Maintenance (%)</mat-label>
            <input matInput id="project-maintenance" aria-label="Maintenance (%)" type="number" formControlName="maintenance" min="0" max="100" step="0.1" (input)="onMaintenanceChange()">
            @if (form.get('maintenance')?.hasError('min')) {
              <mat-error>Min 0</mat-error>
            }
            @if (form.get('maintenance')?.hasError('max')) {
              <mat-error>Max 100</mat-error>
            }
            @if (form.get('maintenance')?.hasError('maxOneDecimal')) {
              <mat-error>Max 1 decimal place</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-sm-6 form-group">
          <mat-form-field appearance="outline">
            <mat-label>Expansion (%)</mat-label>
            <input matInput id="project-expansion" aria-label="Expansion (%)" type="number" formControlName="expansion" min="0" max="100" step="0.1" (input)="onExpansionChange()">
            @if (form.get('expansion')?.hasError('min')) {
              <mat-error>Min 0</mat-error>
            }
            @if (form.get('expansion')?.hasError('max')) {
              <mat-error>Max 100</mat-error>
            }
            @if (form.get('expansion')?.hasError('maxOneDecimal')) {
              <mat-error>Max 1 decimal place</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 checkbox-group">
          <input type="checkbox" formControlName="focus"/> <span>Focus Project</span>
        </div>
      </div>
      <div>
        <span class="admin-notification">Update might require Admin access, please contact <a href="mailto:justus.imhoff@tkelevator.com">Justus Imhoff</a></span>
      </div>
      <div class="panel-body">
        <button type="button" (click)="backButtonHandler($event)" mat-raised-button class="btn button-color-fix_red">
          <mat-icon class="icon-color-fix">arrow_back_ios</mat-icon>
          Back
        </button>
        <button mat-raised-button type="submit" class="btn button-color-fix pull-right" [disabled]="!form.valid">
          {{isEditMode ? 'Update' : 'Create'}}
          <mat-icon class="icon-color-fix">save</mat-icon>
        </button>
      </div>
    </form>
  </div>
</div>